import * as Types from '../types.generated'

import { gql } from '@apollo/client'
export const ProjectDetailsFragmentDoc = gql`
  fragment ProjectDetails on Project {
    id
    name
    description
    type
    slug
    explorerApiUrl
    frameworks {
      name
    }
    logo {
      url
      isBright
    }
    socialUrls {
      type
      url
    }
  }
`
export type ProjectDetailsFragment = {
  __typename?: 'Project'
  id: string
  name: string
  description: string
  type: Types.ProjectType
  slug: string
  explorerApiUrl: string
  frameworks: Array<{ __typename?: 'BlockchainFramework'; name: string }>
  logo?: { __typename?: 'LogoInformation'; url: string; isBright: boolean } | null
  socialUrls: Array<{ __typename?: 'SocialURL'; type: Types.SocialUrlType; url: string }>
}
